import React from "react";
import { Container, Row, Col, Card, CardBody, Button, Badge } from "reactstrap";

const Support = () => {
  const contactItems = [
    {
      icon: "fa-mobile",
      title: "شماره موبایل",
      value: "09123456789",
      href: "tel:09123456789",
      buttonText: "تماس",
      iconColor: "#2196f3",
      iconBg: "#e3f2fd",
      buttonColor: "primary",
    },
    {
      icon: "fa-phone",
      title: "تلفن ثابت",
      value: "02112345678",
      href: "tel:02112345678",
      buttonText: "تماس",
      iconColor: "#00acc1",
      iconBg: "#e0f7fa",
      buttonColor: "info",
    },
    {
      icon: "fa-envelope",
      title: "ایمیل",
      value: "support@example.com",
      href: "mailto:support@example.com",
      buttonText: "ارسال ایمیل",
      iconColor: "#43a047",
      iconBg: "#e8f5e9",
      buttonColor: "success",
    },
    {
      icon: "fa-globe",
      title: "وب‌سایت",
      value: "www.example.com",
      href: "https://www.example.com",
      buttonText: "مشاهده سایت",
      target: "_blank",
      iconColor: "#607d8b",
      iconBg: "#eceff1",
      buttonColor: "secondary",
    },
  ];

  return (
    <div
      className="py-4"
      style={{
        minHeight: "100%",
        direction: "rtl",
        backgroundColor: "#f5f7fa",
        color: "#212529",
      }}
    >
      <Container>
        {/* Header */}
        <Row className="justify-content-center mb-4">
          <Col xs="12" lg="10">
            <Card
              className="border-0 shadow-sm"
              style={{
                borderRadius: "16px",
                backgroundColor: "#ffffff",
                overflow: "hidden",
              }}
            >
              <CardBody className="p-4">
                <Row className="align-items-center">
                  <Col xs="12" md="8" className="text-center text-md-right">
                    <div className="mb-3">
                      <Badge
                        pill
                        className="px-3 py-2"
                        style={{
                          backgroundColor: "#e3f2fd",
                          color: "#1976d2",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa fa-headphones ml-2" />
                        پشتیبانی
                      </Badge>
                    </div>

                    <h4
                      className="font-weight-bold mb-2"
                      style={{
                        color: "#212529",
                      }}
                    >
                      در کنار شما هستیم
                    </h4>

                    <p
                      className="mb-0"
                      style={{
                        color: "#6c757d",
                        lineHeight: "2",
                        fontSize: "14px",
                      }}
                    >
                      در صورت نیاز به راهنمایی یا دریافت اطلاعات بیشتر،
                      می‌توانید از طریق یکی از راه‌های ارتباطی زیر با واحد
                      پشتیبانی در ارتباط باشید.
                    </p>
                  </Col>

                  <Col xs="12" md="4" className="text-center mt-4 mt-md-0">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "90px",
                        height: "90px",
                        backgroundColor: "#e3f2fd",
                      }}
                    >
                      <i
                        className="fa fa-headphones"
                        style={{
                          fontSize: "42px",
                          color: "#2196f3",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Contact Cards */}
        <Row className="justify-content-center">
          {contactItems.map((item, index) => (
            <Col key={index} xs="12" sm="6" lg="3" className="mb-4">
              <Card
                className="h-100 border-0 shadow-sm"
                style={{
                  borderRadius: "14px",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
              >
                <CardBody className="text-center p-4">
                  {/* Icon */}
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{
                      width: "65px",
                      height: "65px",
                      backgroundColor: item.iconBg,
                    }}
                  >
                    <i
                      className={`fa ${item.icon}`}
                      style={{
                        fontSize: "27px",
                        color: item.iconColor,
                      }}
                    />
                  </div>

                  {/* Title */}
                  <h6
                    className="font-weight-bold mb-3"
                    style={{
                      color: "#343a40",
                    }}
                  >
                    {item.title}
                  </h6>

                  {/* Value */}
                  <div
                    className="mb-4"
                    style={{
                      minHeight: "24px",
                      direction: "ltr",
                      color: "#6c757d",
                      fontSize: "14px",
                      wordBreak: "break-word",
                    }}
                  >
                    {item.value}
                  </div>

                  {/* Button */}
                  <Button
                    color={item.buttonColor}
                    size="sm"
                    block
                    href={item.href}
                    target={item.target}
                    rel={
                      item.target === "_blank"
                        ? "noopener noreferrer"
                        : undefined
                    }
                    style={{
                      borderRadius: "8px",
                    }}
                  >
                    <i
                      className={`fa ${
                        item.icon === "fa-envelope"
                          ? "fa-paper-plane"
                          : item.icon === "fa-globe"
                            ? "fa-external-link"
                            : "fa-phone"
                      } ml-2`}
                    />

                    {item.buttonText}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Footer */}
        <Row className="justify-content-center">
          <Col xs="12" lg="10">
            <div className="text-center mt-2">
              <small
                style={{
                  color: "#868e96",
                }}
              >
                <i className="fa fa-clock-o ml-1" />
                کارشناسان پشتیبانی آماده پاسخگویی به شما هستند.
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Support;
